export const enum ContentState {
  NotYetStarted = 'NOT_YET_STARTED',
  Started = 'STARTED',
  Ended = 'ENDED',
}

export const enum SessionState {
  NotYetStarted = 'NOT_YET_STARTED',
  Started = 'STARTED',
  Ended = 'ENDED',
}

export const enum MediaState {
  NotYetStarted = 'NOT_YET_STARTED',
  Started = 'STARTED',
}
